__turbopack_context__.v({
  "active": "index-module-scss-module__Xitz5q__active",
  "empty": "index-module-scss-module__Xitz5q__empty",
  "item": "index-module-scss-module__Xitz5q__item",
  "list": "index-module-scss-module__Xitz5q__list",
  "show": "index-module-scss-module__Xitz5q__show",
});
